import { render, staticRenderFns } from "./chip-primary6.vue?vue&type=template&id=3a5ff920&scoped=true&"
import script from "./chip-primary6.vue?vue&type=script&lang=js&"
export * from "./chip-primary6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ff920",
  null
  
)

export default component.exports